import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createChartingPresetQueries(client: StoxlyClient) {
  return createQueryKeys('chartingPresets', {
    // ['chartingPresets', 'all']
    all: {
      queryKey: null,
      queryFn: ({ signal }) => client.chartingPresetsFindAll({ signal }),
    },

    // ['chartingPresets', 'assignment', symbol]
    assignment: (symbol: string) => ({
      queryKey: [symbol],
      queryFn: ({ signal }) =>
        client.chartingPresetsResolveAssignment({ params: { symbol }, signal }),
    }),
  });
}

export function createChartingPresetMutations(client: StoxlyClient) {
  return {
    create: {
      mutationFn: (body: Body<'chartingPresetsCreate'>) => client.chartingPresetsCreate(body),
    },
    update: {
      mutationFn: ({ id, ...body }: Body<'chartingPresetsUpdate'> & { id: string }) =>
        client.chartingPresetsUpdate(body, { params: { id } }),
    },
    delete: {
      mutationFn: (id: string) => client.chartingPresetsDelete(undefined, { params: { id } }),
    },
    setDefault: {
      mutationFn: (id: string) => client.chartingPresetsSetDefault(undefined, { params: { id } }),
    },
    clearDefault: {
      mutationFn: () => client.chartingPresetsClearDefault(undefined),
    },
    assign: {
      mutationFn: ({ symbol, presetId }: { symbol: string; presetId: string | null }) =>
        client.chartingPresetsAssign({ presetId }, { params: { symbol } }),
    },
    unassign: {
      mutationFn: (symbol: string) =>
        client.chartingPresetsUnassign(undefined, { params: { symbol } }),
    },
  };
}
